export default __webpack_public_path__ + "static/media/touchTwo.7268601b.svg";